module.exports = __webpack_public_path__ + "img/power-system.4a3c27e5.svg";